import React from "react";
import { Link } from "react-router-dom";

import styles from "./Footer.module.scss";
import penspaceLogo from "../../images/penspace-logo.png";

export default function Footer({ showDeleteAccount = false }) {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.footerContent}>
          <div className={styles.footerLogo}>
            <Link to="/" className={styles.footerLogoLink} aria-label="Go to Home">
              <img src={penspaceLogo} alt="Penspace" className={styles.footerLogoImg} />
            </Link>
          </div>
          <div className={styles.footerLinks}>
            <Link to="/privacy.html" className={styles.footerLink}>
              Privacy Policy
            </Link>
            <Link to="/terms.html" className={styles.footerLink}>
              Terms of Service
            </Link>
            {showDeleteAccount && (
              <Link to="/delete-account" className={styles.footerLink}>
                Delete Account
              </Link>
            )}
            <Link to="/#help" className={styles.footerLink}>
              Support
            </Link>
            <a
              href="mailto:support@penspace.in?subject=Penspace%20Support&body=Hi%20Penspace%20Team,"
              className={styles.footerLink}
            >
              Contact
            </a>
          </div>
        </div>
        <div className={styles.footerBottom}>
          <p>&copy; 2024 Penspace. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
